import { apiSections }                 from 'dmpconnectjsapp-base/constants';
import PropTypes                       from 'prop-types';
import React, { Fragment }             from 'react';
import { Highlighter, Menu, MenuItem } from 'react-bootstrap-typeahead';
import Form                            from 'react-bootstrap/Form';
import { connect }                     from 'react-redux';
import { groupBy }                     from '../../dmpconnect/helpers/jsUtils';
import CustomTypeahead                 from '../Common/Form/Input/CustomTypeahead';

export const getAtcCodeDesc = (atcCodes, code) => {
  const atcInfos = atcCodes.find(atc => atc.s_code === code);
  if (atcInfos && atcInfos.Names) {
    return atcInfos.Names.s_fr;
  }
  return 'NC';
};

const renderGroupMenu = (results, menuProps, state) => {
  let index    = 0;
  const groups = groupBy(results, 'group');
  
  const items = Object.keys(groups).filter(g => g !== 'undefined').map(group => (
    <Fragment key={`categoryInputGroup${group.replace(/\s/g, '')}`}>
      {index !== 0 && <Menu.Divider/>}
      <Menu.Header>{group}</Menu.Header>
      {groups[group].map((i) => {
        const item = (
          <MenuItem key={index} option={i} position={index}>
            <Highlighter search={state.text}>
              {i.Names.s_fr}
            </Highlighter>
          </MenuItem>
        );
        
        index += 1;
        return item;
      })}
    </Fragment>
  ));
  
  return <Menu {...menuProps}>{items}</Menu>;
};

const AtcCodeImmunizationInput = ({
  atcImmunizationsCodes, value, error, name, isInvalid, ...props
}) => {
  const grouped = React.useMemo(() => {
    const sections             = atcImmunizationsCodes.filter(c => c.i_level === 4);
    const arrayWithoutSections = atcImmunizationsCodes.filter(c => c.i_level >= 4);
    return arrayWithoutSections.map(code => {
      const group = sections.find(s => s.s_code === code.s_code.substring(0, 5));
      return { ...code, group: group ? group.Names.s_fr : 'NC' };
    });
  }, [atcImmunizationsCodes]);
  
  
  return (
    <>
      <CustomTypeahead
        className={`custom-typeahead ${isInvalid ? 'is-invalid' : ''}`}
        name={name}
        id={name}
        options={grouped}
        selectionRule={item => item.s_code === value}
        labelKey={(option) => option.Names.s_fr}
        valueKey="s_code"
        value={value}
        inputProps={{ size: 'sm', isInvalid }}
        multiple={false}
        renderMenu={renderGroupMenu}
        {...props}
      />
      <Form.Control.Feedback type="invalid">
        {error}
      </Form.Control.Feedback>
    </>
  );
};

AtcCodeImmunizationInput.propTypes = {
  onChange            : PropTypes.func.isRequired,
  choices             : PropTypes.array,
  value               : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error               : PropTypes.string,
  name                : PropTypes.string.isRequired,
  isInvalid           : PropTypes.bool,
  atcImmunizationsCode: PropTypes.array,
};

AtcCodeImmunizationInput.defaultProps = {
  value                : null,
  error                : null,
  isInvalid            : false,
  atcImmunizationsCodes: [],
  choices: [],
};

function mapStateToProps(state) {
  const { dmpconnectInteropCodes: { [apiSections.ATC_IMMUNIZATION_CODES]: { Codes = [] } = {} } } = state;
  
  return {
    atcImmunizationsCodes: Codes,
  };
}

export default connect(mapStateToProps)(AtcCodeImmunizationInput);
